import { ComponentProps } from "react";
import { BlockTitle } from "@blocks/Blocks";
import Ad from "@components/Advertisement/Ad";
import Card from "@particles/card/Card";
import BreakingNewsStories from "@routes/Home/BreakingNews/BreakingNewsStories";
import { sectionNavigationItems } from "@util/constant";

type BreakingNewsProps = {
  /** Additionl styling for the component */
  className?: string;
  /** The list of the article card props */
  cardProps: ComponentProps<typeof Card>[];
};

const section = sectionNavigationItems["breaking-news"];

/**
 * Renders the Home - breaking news section with a title and a list of articles.
 * https://www.figma.com/design/rmzJoZwUpb3iLm6lMDXJ2W/BT-MASTER--WEB-?node-id=1312-1973&t=g7P8QlYHW3Ymfii6-4
 */
const BreakingNews = ({
  className,
  cardProps,
}: BreakingNewsProps): React.ReactElement => {
  return (
    <section
      className={className}
      data-testid="homepage-breaking-news-stories-component"
    >
      <BlockTitle link={section?.link} text={section?.label?.toUpperCase()} />

      <div className="stories lg:grid lg:grid-cols-3 lg:gap-4">
        <div className="lg:col-span-2 lg:grid lg:grid-cols-2">
          {cardProps.map((card, index) => {
            return (
              <BreakingNewsStories
                cardProps={card}
                index={index}
                key={card.id}
              />
            );
          })}
        </div>

        <div className="bg-gray-125 lg:col-start-3 lg:h-auto">
          <div className="sticky top-[40px]">
            <Ad
              adType="imu1"
              className="-mx-3 flex flex-col items-center justify-center border-t border-gray-175 bg-gray-125 py-6 md:mx-0"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default BreakingNews;
